import { useEffect } from "react";

/**
 * Swaps the <link rel="manifest"> tag to the admin-scoped manifest (start_url=/admin)
 * while an admin page is mounted. Without this, "Add to Home Screen" on /admin or
 * /admin/login would still launch the patient-facing manifest (start_url="/"), so the
 * installed icon would always open the booking home page instead of the admin panel.
 */
export function useAdminManifest() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    const original = link.getAttribute("href");
    link.setAttribute("href", "/admin-manifest.json");
    return () => {
      if (original) link.setAttribute("href", original);
    };
  }, []);
}
